import { inject, observer } from 'mobx-react';
import * as React from 'react';

import { adaptSearchCriteria } from 'src/common/stores/adapters/bex-api/common/search-criteria-adapter';
import { CurrentHotelStore } from 'src/common/stores/current-hotel-store';
import { getShoppingContextInput } from 'src/common/stores/adapters';
import { MultiItemStore } from 'src/common/stores/multi-item-store';
import { usePlatformContext } from 'src/common/stores/contexts/platformContext';
import { useSearchCriteriaContext } from 'src/common/stores/contexts';
import CarouselContext from 'src/common/stores/contexts/carousel-context-provider';

import { SharedUiSimilarPropertiesWrapper, SimilarPropertiesWrapperProps } from '../shared-ui/details/shared-ui-similar-properties';

interface PropertyBottomCarouselWrapperProps {
  currentHotel?: CurrentHotelStore;
  multiItem?: MultiItemStore;
}

export const PropertyBottomCarouselWrapper: React.FunctionComponent<PropertyBottomCarouselWrapperProps> = inject(
  'currentHotel',
  'multiItem'
)(
  observer(props => {
    const { carouselNames } = React.useContext(CarouselContext);
    const context = usePlatformContext();
    const searchCriteria = useSearchCriteriaContext();
    const multiItemContext = props.multiItem?.multiItemContext;
    const shoppingContext = getShoppingContextInput(multiItemContext);
    const propertySearchCriteria = adaptSearchCriteria(context, searchCriteria);

    if (carouselNames.topCarousel === 'similar-properties') {
      return null;
    }

    const inputProps: SimilarPropertiesWrapperProps = {
      inputs: {
        propertyId: String(props.currentHotel?.hotelId),
        searchCriteria: propertySearchCriteria,
        shoppingContext,
      },
    };

    return <SharedUiSimilarPropertiesWrapper inputs={inputProps.inputs} />;
  })
);
